module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.features.length) ? _c('swiper', {
    staticClass: "news-internal",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.features), function(feature, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('features-slide-element', {
      attrs: {
        "feature": feature
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Chevron_thin_left",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979s-0.701,0.271-0.969,0l-7.83-7.908\n                c-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418\n                z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Chevron_thin_right",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908\n                c0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"
    }
  })])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8735f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/features/features-slide.vue
// module id = 164
// module chunks = 5